import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, useSlots, watch } from "vue";
import { TableProps, TableRow } from "@/types";
import { sortRows } from "@/util";
import { useVModel } from "@/hooks";


/**
 * A generic data table.
 */
const __default__ = {
  name: "DataTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    columns: {},
    visibleColumns: {},
    rows: {},
    rowKey: { type: [String, Function] },
    rowsPerPage: {},
    selection: {},
    selected: {},
    expanded: {},
    filterText: {},
    filter: { type: Function },
    sortBy: {},
    sortDesc: { type: Boolean },
    sort: { type: Function },
    separator: {},
    customCells: {},
    dense: { type: Boolean },
    virtualScroll: { type: Boolean },
    loading: { type: Boolean },
    dataCy: {}
  },
  emits: ["update:selected", "update:visibleColumns", "update:expanded", "update:sortBy", "row-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();

const selectedRows = useVModel(props, "selected");
const visibleCols = useVModel(props, "visibleColumns");
const expandedRows = useVModel(props, "expanded");
const sortBy = useVModel(props, "sortBy");
const sortDesc = useVModel(props, "sortDesc");

const sort = computed(() => props.sort || sortRows);

const customCellSlots = computed(() =>
  props.customCells
    ? props.customCells.map((name) => `body-cell-${String(name)}`)
    : []
);

const pagination = ref({
  sortBy: props.sortBy,
  descending: props.sortDesc,
  rowsPerPage: props.rowsPerPage || 20,
  page: 1,
});

watch(
  () => props.sortBy,
  (sort) => {
    if (pagination.value.sortBy === sort) return;

    pagination.value.sortBy = sort;
  }
);

watch(
  () => pagination.value.sortBy,
  (sort) => {
    if (sortBy.value === sort) return;

    sortBy.value = sort;
  }
);

watch(
  () => props.sortDesc,
  (desc) => {
    if (pagination.value.descending === desc) return;

    pagination.value.descending = desc;
  }
);

watch(
  () => pagination.value.descending,
  (desc) => {
    if (sortDesc.value === desc) return;

    sortDesc.value = desc;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_table, {
      expanded: _unref(expandedRows),
      "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expandedRows) ? (expandedRows).value = $event : null)),
      selected: _unref(selectedRows),
      "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedRows) ? (selectedRows).value = $event : null)),
      "visible-columns": _unref(visibleCols),
      "onUpdate:visibleColumns": _cache[2] || (_cache[2] = ($event: any) => (_isRef(visibleCols) ? (visibleCols).value = $event : null)),
      pagination: pagination.value,
      "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((pagination).value = $event)),
      flat: "",
      dense: props.dense,
      loading: props.loading,
      columns: props.columns,
      filter: props.filterText,
      "filter-method": props.filter,
      rows: props.rows,
      "row-key": props.rowKey,
      selection: props.selection,
      "sort-method": sort.value,
      separator: props.separator,
      "virtual-scroll": props.virtualScroll,
      "data-cy": props.dataCy,
      "table-header-class": "text-primary",
      class: "data-table",
      onRowClick: _cache[4] || (_cache[4] = (e, r, i) => emit('row-click', e, r, i))
    }, _createSlots({
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 2
    }, [
      (_unref(slots).top)
        ? {
            name: "top",
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, "top", _normalizeProps(_guardReactiveProps(scope)))
            ]),
            key: "0"
          }
        : undefined,
      (_unref(slots).header)
        ? {
            name: "header",
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps(scope)))
            ]),
            key: "1"
          }
        : undefined,
      (_unref(slots).body)
        ? {
            name: "body",
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, "body", _normalizeProps(_guardReactiveProps(scope)))
            ]),
            key: "2"
          }
        : undefined,
      (_unref(slots).selection)
        ? {
            name: "body-selection",
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, "selection", _normalizeProps(_guardReactiveProps(scope)))
            ]),
            key: "3"
          }
        : undefined,
      (_unref(slots).item)
        ? {
            name: "item",
            fn: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(scope)))
            ]),
            key: "4"
          }
        : undefined,
      _renderList(customCellSlots.value, (name) => {
        return {
          name: name,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(scope)))
          ])
        }
      })
    ]), 1032, ["expanded", "selected", "visible-columns", "pagination", "dense", "loading", "columns", "filter", "filter-method", "rows", "row-key", "selection", "sort-method", "separator", "virtual-scroll", "data-cy"]),
    _renderSlot(_ctx.$slots, "bottom")
  ]))
}
}

})